import { createContext, useState } from "react";
import { post } from "../../core/client";
import AvisFormLegalModal from "./AvisFormLegalModal";

interface LegalTexts {
    contracts: LegalContractItem[];
    consents: LegalContractConsentItem[];
}

interface LegalContractItem {
    type: string;
    text: string;
}

interface LegalContractConsentItem {
    type: string;
    text: string;
    contractType: string;
    required: boolean;
}

export enum LegalContractType {
    KAMPANYA_KOSULLARI = 'KAMPANYA_KOSULLARI',
    KIRALAMA_KOSULLARI = 'KIRALAMA_KOSULLARI',
}

interface AvisFormContextModel {
    showLegalTextModal: boolean;
    legalTextLoading: boolean;
    legalTexts: LegalTexts | null;
    selectedConsentType: string;
    loadLegalTexts: (types: LegalContractType[]) => void;
    openLegalTextModal: (type: LegalContractType) => void;
    closeLegalTextModal: () => void;
}

const defaultModel: AvisFormContextModel = {
    showLegalTextModal: false,
    legalTextLoading: false,
    legalTexts: null,
    selectedConsentType: "",
    loadLegalTexts: (types: LegalContractType[]) => { },
    openLegalTextModal: (type: LegalContractType) => { },
    closeLegalTextModal: () => { },
}

export const AvisFormContext = createContext<AvisFormContextModel>(defaultModel);

const AvisFormContextProvider = (props: any) => {

    const [legalTextLoading, setLegalTextLoading] = useState(false);
    const [showLegalTextModal, setShowLegalTextModal] = useState(false);
    const [legalTexts, setLegalTexts] = useState<LegalTexts | null>(defaultModel.legalTexts);
    const [selectedConsentType, setSelectedConsentType] = useState<string>(defaultModel.selectedConsentType);

    const loadLegalTexts = async (types: LegalContractType[]) => {
        if(legalTexts != null) return;

        setLegalTextLoading(true);
        const request = {consentType: types.map(x => LegalContractType[x])};
        //var { data, fail, errorMessage } = await post<LegalTexts>(`api/membership/get-form-legal-consents`, request);
        var fail = false;
        var contract: LegalContractItem = {
            type: LegalContractType.KAMPANYA_KOSULLARI,
            text: avisStaticConditionText()
        }
        var consent: LegalContractConsentItem = {
            type: LegalContractType.KAMPANYA_KOSULLARI,
            text: "Consent",
            contractType: LegalContractType.KAMPANYA_KOSULLARI,
            required: true
        }
        var data: LegalTexts = {
            contracts: [contract],
            consents: [consent]
        }
        setLegalTextLoading(false);
        if (!fail && data) {
            
            setLegalTexts(data)
        }
    };

    const openLegalTextModal = (type: LegalContractType) => {
        setSelectedConsentType(LegalContractType[type]);
        setShowLegalTextModal(true);
    }

    const closeLegalTextModal = () => {
        setSelectedConsentType("");
        setShowLegalTextModal(false);
    }

    const avisStaticConditionText = () => {
        return `<html>


        <h3>KİRALAMA KOŞULLARI</h3><br><br>
        
        •	Rezervasyon talebi kiralama tarihinden minimum 1 ay önce iletilmelidir.<br><br>
        •	İnsan Kaynakları’na başvuru yapıldıktan sonra, 24 saat içinde, başvuru formunda belirtilen  e-posta adresine rezervasyon formu iletilecektir.<br><br>
        •	Rezervasyon talebine, AVIS’e ulaştıktan sonra 24 saat içinde dönüş sağlanacaktır.<br><br>
        •	Kiralama ayrıcalığının kullanılabilmesi için Koç Topluluğu’nda çalışıyor olma koşulu vardır. Kiralama tarihinden önce Koç Topluluğu’ndan ayrılma durumunda rezervasyon iptal edilecektir.<br><br>
        •	Rezervasyon araç grubu bazında gerçekleşecek olup araç gruplarında marka - model - renk ve yakıt garantisi verilememektedir.<br><br>
        •	Günlük araç kiralama hizmetinde kilometre kullanım hakkı günlük 500 km olmak şartı ile 7 gün ve üzeri kiralamalarda, kiralama başına 4000 km ile sınırlıdır. Kilometre aşım ücreti araç grup bazında KM başına değişkenlik göstermektedir. Güncel bilgi kiralama ofisinden kiralama esnasında alınabilir.<br><br>
        •	Fiyatlara akaryakıt, tek yön gibi ek ürün ve hizmetler dahil olmayıp; yalnızca bir ek sürücü dahildir.<br><br>
        •	Kiralama başlangıcında sürücü adına olan kredi kartından, kiralanacak araç grubuna göre 5.500 – 8.500 TL arasında, depozito tahsilatı yapılacaktır. Depozito olarak tahsil edilen tutar, kiralama bitiminde; varsa ek hizmet, güvenceler, yakıt, hasar, ceza vb. gibi rezervasyonda bulunmayan bedeller düşüldükten sonra aynı karta iade edilecektir.<br><br>
        •	Yaş ve Ehliyet Deneyimi;<br>
        
         &nbsp &nbsp &nbsp o	Comfort segment (O) araç gruplarında 23 yaş, 2 yıllık B sınıf ehliyet  deneyimi,<br>
         &nbsp &nbsp &nbsp o	Premium segment (C) araç gruplarında 27 yaş, 3 yıllık B sınıf ehliyet deneyimi aranmaktadır.<br><br>
        •	AVIS filosunda yalnızca B sınıf ehliyete uygun araçlar bulunduğundan başka sınıf ehliyetler kabul edilememektedir.<br><br>
        •	Normal şartlar altında AVIS ofislerinde araç kiralama değerlendirme analizi yapılmaktadır ve kriterleri karşılayamayan kişiler için araç teslimatı gerçekleştirilmemektedir. Ancak KoçAilem Evlilik Ayrıcalıkları özelinde ana sürücü olan aktif Koç Topluluğu çalışanına kriterler karşılanmasa dahi araç teslimatı gerçekleştirilecektir.<br><br>
        •	Ana sürücü, yalnızca evlenecek olan Koç Topluluğu çalışanı olabilir. Bu hak başka bir kişiye devredilemez.<br><br>
        •	Ek sürücü kaydı için ek sürücünün aracı teslim alırken mutlaka ana sürücü ile ofiste olması gereklidir. Araç rezervasyon formunda, ek sürücü bilgilerinin girilmiş olması yeterli değildir.<br><br>
        •	Aracı alırken ana sürücünün mutlaka AVIS ofisinde olması gerekmektedir. Ana sürücü olmadan ek sürücü aracı teslim alamaz.<br><br>
        •	Araç iadesini ek sürücü tek başına yapabilir. Araçta, kapsam dışında bir hasar olması ya da ek bir bedel çıkması durumunda ana sürücünün kredi kartından temin edilir. Sisteme sadece ana sürücünün kredi kartı eklenebilir.<br><br>
        •	Hak kapsamında, tercihe bağlı olarak; 2 gün ve O veya 1 gün C segment araç grubu tercihinde bulunulabilir.<br><br>
        Yine hak kapsamında talep edilirse; C segment araç grubu, 2 gün olarak kiralanabilir. İlgili fayda kapsamındaki özel fiyatıyla 2. gün şahsi kredi kartı ile ücretini ödeyerek kiralayabilir.<br><br>
        Buradaki fiyatlandırma; döneme ve kampanyaya özeldir.
        C grubu için söz konusu 2. gün; hemen 1. günün devamında tercih edilebilir; 1. gün kiralamadan bağımsız olarak daha sonra “KoçAilem Evlilik Ayrıcalıkları” kapsamında 2. gün C grup kiralanamaz.<br><br>
        •	Kampanya kapsamındaki kiralama hakkının ücretli bir kiralama ile birleştirerek uzatılması istenmesi durumunda  AVIS Genel Kiralama Koşulları gereği, her iki kiralama için de ayrı işlemler yapılması gerekmektedir. Bu kapsamda ikinci kira sözleşmesi için tekrar ofise gelinmesi gerekir.  Uzatma durumunda evlilik kampanyası kapsamında uygulanan faydalar yeni anlaşmada kullanılamaz.(Findeks sorgusunun yapılmaması, ücretsiz ek sürücü kuralları, fiyatlandırma gibi)
        •	Konfirmasyonu sağlanan rezervasyon için değişiklik ve iptal yapılamaz.<br><br>
        •	AVIS, araç kiralama tutarı dışında kalan ücretlerde ve kiralama koşullarında değişiklik yapma hakkını saklı tutar.<br><br>
        •	Otokoç; çalışanları için kazanılan hak kapsamında Otokoç çalışan fiyat koduna özel ayrıcalıklar uygulanmayacaktır.<br><br>
        `;
    }

    return (
        <AvisFormContext.Provider value={{
            showLegalTextModal, legalTextLoading, legalTexts, selectedConsentType,
            loadLegalTexts, openLegalTextModal, closeLegalTextModal
        }}>
            {props.children}
            <AvisFormLegalModal
                onClose={closeLegalTextModal} />
        </AvisFormContext.Provider>
    );
}

export default AvisFormContextProvider;
